import { Variant } from '../typography/model';

export const ACCORDION_HORIZONTAL_SPACING = 2;
export const ACCORDION_VERTICAL_SPACING = 2;
export const ACCORDION_SUMMARY_ICON_SPACING = 1;
export const ACCORDION_SUMMARY_DESKTOP_TYPOGRAPHY_VARIANT: Variant = 'h6';
export const ACCORDION_SUMMARY_MOBILE_TYPOGRAPHY_VARIANT: Variant = 'button';
export const ACCORDION_DETAILS_TYPOGRAPHY_VARIANT: Variant = 'body';
